import {
  sendGetRequest,
  sendPostRequest,
  sendFileFormDataRequest,
  sendDeleteRequest,
  sendListRequest,
  sendUpdateRequest,
  sendListRequestWithData,
} from './crud';

// prepare data functions
const prepareDemandPartnerData = (data) => {
  // if (data.qps) {
  //   data.qps = parseInt(data.qps);
  // }
  if (data.bundles) {
    data.app_bundles = {
      bundles: JSON.parse(data.bundles),
      is_black_list: data.is_black_list == 'true',
    };
  }
  delete data.bundles;
  delete data.is_black_list;
  return { values: data };
};
const prepareReportData = (data) => {
  if (data.params) {
    data.params = JSON.parse(data.params);
  }
  return { values: data };
};
const prepareCampaignData = (data) => {
  // new campaign
  if (data.targeting_geo) {
    data.targeting = {};
    if (data.targeting_device) {
      data.targeting.device = data.targeting_device;
      delete data.targeting_device;
    }
    if (data.targeting_geo) {
      data.targeting.geo = data.targeting_geo;
      delete data.targeting_geo;
    }
    if (data.targeting_parting) {
      data.targeting.parting = data.targeting_parting;
      delete data.targeting_parting;
    }
    if (data.targeting_coordinates) {
      data.targeting.coordinates = data.targeting_coordinates;
      delete data.targeting_coordinates;
    }
    if (data.frequency_capping) {
      data.targeting.frequency_capping = data.frequency_capping;
      delete data.frequency_capping;
    }
    if (data.segment_period) {
      data.targeting.segment_period = data.segment_period;
      delete data.segment_period;
    }
    if (data.targeting_segments) {
      data.targeting.segments = data.targeting_segments;
      delete data.targeting_segments;
    }
    if (data.targeting_time_of_day) {
      data.targeting.time_of_day = JSON.parse(data.targeting_time_of_day);
      delete data.targeting_time_of_day;
    }
    if (data.brand_study) {
      data.brand_study = JSON.parse(data.brand_study);
    }
  }
  if (data.publishers) {
    data.publishers = JSON.parse(data.publishers);
  }
  if (data.budget) {
    data.budget = parseFloat(data.budget);
  }
  if (data.impressions) {
    data.impressions = parseFloat(data.impressions);
  }
  if (data.target_price) {
    data.target_price = parseFloat(data.target_price);
  }
  // console.log("apiData", data)
  return { values: data };
};

const prepareDataFunctions = {
  demand: prepareDemandPartnerData,
  reports: prepareReportData,
  campaign: prepareCampaignData,
  flight: prepareCampaignData,
};

// query not generic
export const getReport = async (pageSize, page, sortBy, sortOrder, report_id, filter = {}) => {
  const queryString = Object.keys(filter)
    .filter((key) => !!filter[key])
    .map((key) => key + '=' + filter[key])
    .join('&');

  return await sendListRequest(
    `/reports/get/${report_id}/data?${queryString}`,
    pageSize,
    page,
    sortBy,
    sortOrder
  );

  // TODO find out why the error handling above in getReportById was used here
};

export const checkQuery = async (data,filter = {}) => {
  let page = 0;
  let pageSize = 100;
  let sortBy = 'start_at';
  let sortOrder = 'ASC';
  const queryString = Object.keys(filter)
    .filter((key) => !!filter[key])
    .map((key) => key + '=' + filter[key])
    .join('&');

  return await sendListRequestWithData(
    `/reports/testquery/data?${queryString}`,
    { query: data.query, params: data.params },
    pageSize,
    page,
    sortBy,
    sortOrder
  );
};

// general crud functions
export const create = async (module, data) => {
  if (prepareDataFunctions[module]) data = prepareDataFunctions[module](data);
  else data = { values: data };
  return await sendPostRequest(`/${module}/new`, data);
};

export const updatePass = async (module, data) => {
  if (prepareDataFunctions[module]) data = prepareDataFunctions[module](data);
  else data = { values: data };
  return await sendPostRequest(`/${module}/updatepass`, data);
};

export const upload = async (module, data) => {
 return await sendFileFormDataRequest(`/${module}/new`, data);
};
export const update = async (module, data) => {
  if (prepareDataFunctions[module]) data = prepareDataFunctions[module](data);
  else data = { values: data };
  return await sendUpdateRequest(`/${module}/update`, data);
};
export const getById = async (module, id) => {
  return await sendGetRequest(`/${module}/get/${id}`);
};
export const getList = async (module, pageSize, page, sortBy, sortOrder, filter) => {
  return await sendListRequest(`/${module}/get`, pageSize, page, sortBy, sortOrder, filter);
};
export const remove = async (module, data) => {
  return await sendDeleteRequest(`/${module}/delete`, { values: data });
};
